lmApp.service('OperatorResource', ['$resource', function ($resource) {
  return $resource('/discovery:80/sdp/v2/operators/me',
    null,
    {
      get: {
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      update: {
        method: 'PATCH',
        params: {
          id: '@id'
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      getConfigHootko: {
        url: '/discovery:80/sdp/v2/operators/me/config/hootko',
        method: 'GET',
        headers: {
         'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      updateConfigHootko: {
        url: '/discovery:80/sdp/v2/operators/me/config/hootko',
        method: 'PUT',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      }
    });
}]);
